import InAppNotification from './InAppNotification';

export const InAppNotificationIndex = () => {
  return <InAppNotification />;
};

export default InAppNotificationIndex;
